import type { RootState } from 'state';
import type { InputOption } from 'comp/screenBuilder/comp/formBuilder/types/formConfigTypes';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import getCoverageAmountSuppliers from 'routes/tourOperator/bookings/reducers/coverageAmountSuppliers/selectors/getCoverageAmountSuppliers';

function useTableApiOptions(optionsApi?: string): InputOption[] {
  const coverageAmountSuppliers = useSelector<RootState, string[]>(getCoverageAmountSuppliers);

  return useMemo(() => {
    if (optionsApi === 'coverageAmountSuppliers') {
      return coverageAmountSuppliers.map((item) => ({ key: item, value: item }));
    }

    return [];
  }, [optionsApi, coverageAmountSuppliers]);
}

export default useTableApiOptions;
